"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingFileInputReferenceType = exports.TrainingFileTag = void 0;
exports.TrainingFileTag = {
    STATIC_AD_USER_DOWNLOAD: 'STATIC_AD_USER_DOWNLOAD',
    VIDEO_AGENT_FINAL_DOWNLOAD: 'VIDEO_AGENT_FINAL_DOWNLOAD',
    VIDEO_AGENT_SORA_UGC_CLIP: 'VIDEO_AGENT_SORA_UGC_CLIP',
    ACTOR_IMAGE_CANDIDATE_SAMPLE: 'ACTOR_IMAGE_CANDIDATE_SAMPLE',
};
exports.TrainingFileInputReferenceType = {
    BRAND_LOGO: 'BRAND_LOGO',
    PRODUCT_IMAGE: 'PRODUCT_IMAGE',
    FIRST_SCENE: 'FIRST_SCENE',
    REFERENCE_AD: 'REFERENCE_AD',
    ACTOR_BASE_IMAGE: 'ACTOR_BASE_IMAGE',
    REFERENCE_IMAGE: 'REFERENCE_IMAGE',
    ATTACHED_FILE: 'ATTACHED_FILE',
};
